/**
 * 프론트엔드 기능 플래그 (운영 호스트 자동 ON)
 * ===========================================================================
 * 회의록 기능 게이트.
 *
 * 이력:
 *   - 도입 시(법무 검토 전): 기본 OFF + DEV 호스트만 자동 ON — PROD 노출 차단.
 *   - 2026-07-19 대표 결정으로 PROD 전체 활성화 배포됨. 이후 다른 배포 파이프라인이
 *     env 플래그 없이 프론트를 재빌드하면 회의록 UI 가 사라지는 회귀가 발생(실사례 2회:
 *     DEV 2026-07-16, PROD 2026-07-19). → 서비스 호스트(DEV·PROD) 를 런타임 자동 ON
 *     허용 목록에 포함해 어떤 파이프라인의 빌드에서도 유지되게 한다.
 *
 * 정책:
 *   1) 빌드 env REACT_APP_MEETING_NOTES_ENABLED === 'true' 이면 ON (명시적).
 *   2) 또는 런타임 호스트가 서비스 도메인(dev.maryhouseadmin.com / maryhouseadmin.com /
 *      www.maryhouseadmin.com)이면 ON — env 플래그 없는 재빌드에서도 유지.
 *   3) 그 외(localhost 등)는 env 'true' 없으면 OFF.
 *   - 실제 데이터 게이트(녹음 업로드·전사·cron/worker)는 백엔드 시크릿
 *     MEETING_NOTES_ENABLED 가 담당 — 긴급 차단은 백엔드 플래그 OFF 로 1분 내 가능
 *     (프론트 메뉴는 남지만 모든 API 가 404).
 *   - 이 상수는 모듈 로드시 1회 평가된다(브라우저에서 window 접근 가능).
 *     SSR/빌드 시 window 미정의를 대비해 typeof window 로 가드한다.
 */

/** 회의록 UI 를 자동 노출하는 서비스 호스트 목록. */
const MEETING_ENABLED_HOSTS = [
  'dev.maryhouseadmin.com',
  'maryhouseadmin.com',
  'www.maryhouseadmin.com',
];

/** 런타임 호스트가 서비스 도메인인지 여부. */
const isServiceHost =
  typeof window !== 'undefined' &&
  typeof window.location !== 'undefined' &&
  MEETING_ENABLED_HOSTS.includes(window.location.hostname);

/** 회의록 기능 노출 여부(메뉴·라우트). env 'true' 또는 서비스 호스트일 때 ON, 그 외 OFF. */
export const MEETING_NOTES_ENABLED =
  process.env.REACT_APP_MEETING_NOTES_ENABLED === 'true' || isServiceHost;
